import React from 'react';

import { contentStyles } from 'features/menu/components/menu-reorder-widget/menu-reorder-details-drawer/styled';
import { View } from 'react-native';

import { BottomSheet } from 'components/bottom-sheet';

import { MinimalMenuReorderCard } from './minimal-menu-reorder-card';
import { MinimalMenuReorderItemsList } from './minimal-menu-reorder-items-list';
import { MinimalMappedOrder } from './minimal-menu-reorder-widget-types';

export const MinimalMenuReorderDetailsDrawer = ({
  showDrawer,
  toggleDetailsDrawer,
  order,
  openDetailEventMessage,
}: {
  showDrawer: boolean;
  toggleDetailsDrawer: () => void;
  order: MinimalMappedOrder;
  openDetailEventMessage: string;
}) => {
  return (
    <BottomSheet
      onOpenEventMessage={openDetailEventMessage}
      isOpen={showDrawer}
      onClose={toggleDetailsDrawer}
    >
      <View style={contentStyles.content}>
        <MinimalMenuReorderItemsList
          orderEntries={order.orderEntries}
          ListHeaderComponent={() => (
            <MinimalMenuReorderCard
              order={order}
              toggleDetailsDrawer={toggleDetailsDrawer}
              drawerIsOpen={showDrawer}
            />
          )}
        />
      </View>
    </BottomSheet>
  );
};
